//import * as md5 from 'md5'

export default class CoverageC {
  id: string
  lang
  data 
  pages
  story
  
  title: string
  name
  slug: string
  date: string
  modified: string
  status: string
  type: string
  description: string
  link: string
  img: string

  menu_order

  cover

  coverage: string
  
  statut
  
  api
  aware
  social
    
  hash: string
  
  headers

  header_title_show
  back_color

  template
  product

  url
  photos

  lists

  tags

  rubrique

  theme
  navbarTheme1 
  navbarTheme

  navbar1
  navbar1color
  navbar2
  navbar2color
  navmenu
  


  constructor(id, json, lang) {

     //this.template = this.coverage2.data.wp.header[0] || {};
    //var data = json.data || {};
    if(!json) return;

    this.data = json.data || {};
    const wp = this.data.wp || {};
    
    const api = json.data || {};
    const social = json.social || {};
    this.statut = json.statut || {};
    this.story = json.story || null;
    
    let aware = json.aware || [];
    if(aware) {
      //this.social.concat(aware);
      this.aware = this.sumAware(aware);
    }
    else this.aware = {};

    this.social = this.sumSocial(social, aware);
    this.pages = json.pages || null;
    
    //console.log(this.social, this.social, aware);

    /*if(this.statut.default){

      this.statut.default = this.statut.default;

    }

    if(this.statut.cdm2018){
      
      this.statut.cdm2018 = this.statut.cdm2018;

    }

    if(statut.cdm2018){
      
      this.statut.humeur = this.statut.humeur;

    }
    */

    

    
    
    var headers = wp.header || null;
    var template = wp.template || {};

    this.header_title_show = template.header_title_show || false;
    this.back_color = template.back_color || false;

    if(headers) this.headers = headers || null;

    this.theme = wp.theme || {}
    
    if(this.theme.Vibrant) {
      /*this.navbarTheme1 = wp.theme.theme + '-1';
      this.navbarTheme = wp.theme.theme + '-2';

      this.navbar1 = wp.theme.navbar1;
      this.navbar2 = wp.theme.navbar2;

      Results into:
     * Vibrant #7a4426
     * Muted #7b9eae
     * DarkVibrant #348945
     * DarkMuted #141414
     * LightVibrant #f3ccb4
     * */

      this.navbarTheme1 = wp.theme.DarkVibrant;
      this.navbarTheme = wp.theme.Vibrant;

      this.navbar1 = wp.theme.DarkVibrant;
      this.navbar1color = wp.theme.LightVibrant;
      this.navbar2 = wp.theme.Vibrant;
      this.navbar2color = wp.theme.DarkVibrant;
      this.navmenu = wp.theme.LightMuted;
    } else {
      this.navbarTheme1 = '';
      this.navbarTheme = '';

      this.navbar1 = '';
      this.navbar2 = '';
      this.navmenu = '';      
    }


    this.id = id || ''
    let language = wp.lang || {}
    let language2 = language[lang] || {}
    this.title = language2.name;

    this.name = wp.title || 'no name';
    
    if(!this.title) {
      var lang2
      if(lang==='fr') lang2 = 'ang'; else lang2 = 'fr';

      let language2 = language[lang2] || {}
      this.title = language2.name;
    }

    if(!this.title) this.title = wp.title;

    this.slug = wp.slug || 'no_slug' ;
    //this.menu_order = wp.menu_order || '200'   

    this.rubrique = wp.rubrique || {}

    this.date = wp.date || ''
    this.modified = wp.modified || ''
    this.status = wp.status || ''
    this.type = wp.type || ''
    this.description = wp.description || ''
    this.link = wp.link || ''

    this.tags = wp.tags || {}
//if(this.id===1273) this.header = this.coverageService.coverage(1273);

    this.template = wp.template;

    
    this.coverage = wp.coverage || ''
    this.product = wp.product || null //primary

    
    //let statut = json.statut || null
    
   
    
    //this.api = api || {}
    
    //let api = this.api || {}
    //let twitter = api.twitter || null
    

    
    this.img = wp.img || ''
    this.cover = wp.cover || null;

    this.url = wp.url || null;
    this.photos = wp.photos || {};
    
    /*if(!this.api.twitter){} else {
      //if(this.img === 'facebook') this.img = ''
      //else if(this.img === 'twitter') {
        this.img = json.api.twitter.img || ''

        this.cover = json.api.twitter.cover || ''
      //}
    }*/
    
    //this.hash = md5(this.name)
  }

  getstatut(size: number = 100): string {
    
    //if(this.img==='facebook') 
    return 'this.img_twitter'
    //return `http://www.gravatar.com/avatar/${this.hash}?d=retro&s=${size}`
  }

  

  sumSocial (provider, aware) {

    var social = [];

    for(let api in provider) {
      //var data = {}
      var data = provider[api];
      if(aware[api]) data.count = aware[api].count || null;
      social.push(data)
    }

    console.log(social)
  
    return social;

  }


  sumAware (provider) {

    //this.aware 
    //console.log(provider, 'provider')
    //array.for(function (value) {
    //    this.sum += value;
    //}, this);
    var sum = 0;

    for(let api in provider) {
      sum += provider[api].count;
    }
  
    return sum;

  }

}



// WEBPACK FOOTER //
// ./src/models/coveragec.model.ts